import React, { useEffect, useState } from "react";
import { Table, Checkbox, Modal, Button } from "antd";
import { getNotificationList } from "../../../apis/notificationApi";
import AddNotifications from "./AddNotification";
import { Link } from "react-router-dom";
import useTableDragScroll from "../../../hooks/useTableDragScroll";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [expoToken, setExpoToken] = useState("");

  useEffect(() => {
    fetchNotificationsList();
    setLoading(false);
  }, []);

  useTableDragScroll([loading, notifications]);

  const fetchNotificationsList = async () => {
    try {
      const res = await getNotificationList();
      console.log(res);
      setNotifications(res?.result?.notifications || []);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setNotifications([]);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotifications = () => {
    const selectedNotifications = notifications.filter((item) =>
      selectedRowKeys.includes(item.id),
    );
    const tokenList = selectedNotifications
      .map((item) => item.expoToken)
      .join(", ");
    setExpoToken(tokenList);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "Image",
      //   render: (text, record) => <img src={record.image} />,
      render: (text, record) => <img src={record.image} />,
      width: "10%",
    },
    {
      title: "Title",
      dataIndex: "title",
      width: "20%",
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "20%",
    },

    {
      title: "Type",
      dataIndex: "type",
      width: "20%",
    },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      width: "20%",
      render: (text) => text.split("T")[0],
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="text-end">
          <Link
            to={`/viewNotification/${record.id}`}
            className="btn btn-primary mb-3"
          >
            <i className="fa fa-eye m-r-5" /> View
          </Link>
        </div>
      ),
      width: "40%",
    },
  ];

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Button
              className="btn btn-primary mb-3 sn-btn"
              onClick={handleSendNotifications}
            >
              Send Notifications
            </Button>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    Array.isArray(notifications) && notifications.length > 0
                      ? notifications
                      : []
                  }
                  rowKey="id"
                  //   loading={loading}
                  //   pagination={{ pageSize: 10 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add Notifications Modal */}
      <Modal
        title="Send Notifications"
        open={isModalVisible}
        footer={null}
        onCancel={handleModalClose}
        width={600}
      >
        {isModalVisible && (
          <AddNotifications expoToken={expoToken} onClose={handleModalClose} />
        )}
      </Modal>
    </>
  );
};

export default Notifications;
